import React from 'react';
import Modal from '@mui/material/Modal';
import EditHolidayForm from "./EditHolidayForm";

export default function EditHoliday(props) {

    return (

        <Modal
            open
            onClose={props.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <EditHolidayForm holiday={props.holiday} handleClose={props.handleClose}/>

        </Modal>
    );
}
